<template>
  <table class="table">
    <thead>
      <slot name="columns">
        <tr>
          <th v-for="column in columns" :key="column">
            <p v-if="column != 'Numero'">{{ column }}</p>
            <p style="display: flex; align-items: center;" v-else>N°
              <button v-if="!order" type="button" class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation"
                @click="functionOrderData">
                <i style="color: #0d6efd;" class="nc-icon nc-stre-up"></i></button>
              <button v-else type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                aria-expanded="false" aria-label="Toggle navigation" @click="functionOrderData">
                <i style="color: #0d6efd;" class="nc-icon nc-stre-down"></i></button>
            </p>
          </th>
          <th>
            <p>Opciones</p>
          </th>
        </tr>
      </slot>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
          <td :class="{ 'word-break-cell': column == 'Cliente' }" v-for="column in columns" :key="column"
            v-if="hasValue(item, column)">
            <span v-if="column == 'Valor'">{{ parseInt(itemValue(item, column)).toLocaleString('en-EN', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).replace(/\,/g, '.') }}</span>
            <span v-else>{{ itemValue(item, column) }}</span>
          </td>
          <td>
            <vs-tooltip text="Editar">
              <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentEdit(item)">
                <i style="color: #0d6efd;" class="nc-icon nc-settings-gear-64"></i></button>
            </vs-tooltip>
            <vs-tooltip text="Descargar">
              <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentDownload(item)">
                <i style="color: #0d6efd;" class="nc-icon nc-cloud-download-93"></i></button>
            </vs-tooltip>
            <vs-tooltip text="Imprimir POS">
              <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentPrint(item)">
                <i style="color: #0d6efd;" class="nc-icon nc-single-copy-04"></i></button>
            </vs-tooltip>

          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');

export default {
  data() {
    return {
      order: true,
    }
  },
  name: 'l-table1',
  props: {
    columns: Array,
    data: Array
  },
  watch: {
  },
  methods: {
    functionOrderData() {
      if (this.order) {
        this.order = false;
        this.data.sort((a, b) => a.numero - b.numero);
      } else {
        this.order = true;
        this.data.sort((a, b) => b.numero - a.numero);
      }
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined'
    },
    itemValue(item, column) {
      return item[column.toLowerCase()]
    },
    functionComponentDelete(item) {
      this.$emit('functionComponentDelete', item);
    },
    functionComponentEdit(item) {
      this.$emit('functionComponentEdit', item);
    },
    functionComponentDownload(item) {
      this.$emit('functionComponentDownload', item);
    },
    functionComponentPrint(item) {
      let url2 = serverUrl;
      let url3 = `${url2}/api/getPrintViewTicket/${item.id_ticket}`;
      window.open(url3, '_blank');
    },
  },
}
</script>
<style>
.word-break-cell {
  word-break: break-all !important;
}
</style>
